<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
  <h2 class="m-0">{{ parentData.title }}</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>

  <div class="form-cont">
    <mat-dialog-content>
    <form class="example-form" [formGroup]="userInfoFormGroup">
    <div class="mb-3_t">

        <mat-form-field class="w-100" appearance="outline" (click)="pickerA.open()">
          <mat-label>Select open time</mat-label>
          <input matInput
                 name="selected_time_A"
                 [ngxMatTimepicker]="pickerA"
                 readonly
                 formControlName="opentime"/>
          <mat-icon matSuffix style="margin-right: 4px;">
            access_time
          </mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker #pickerA></ngx-mat-timepicker>
      </div>
    <div class="mb-3_t">

        <mat-form-field class="w-100" appearance="outline" (click)="pickerB.open()">
          <mat-label>Select close time</mat-label>
          <input matInput
                 name="selected_time_A"
                 [ngxMatTimepicker]="pickerB"
                 readonly
                 formControlName="closetime"/>
          <mat-icon matSuffix style="margin-right: 4px;">
            access_time
          </mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker #pickerB></ngx-mat-timepicker>
      </div>
    </form>
      <div *ngIf="parentData.data.serviceType == '2'">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Virtual meeting info</mat-label>
          <textarea rows="5" matInput [(ngModel)]="meeting_details"></textarea>
        </mat-form-field>
      </div>
  </mat-dialog-content>
</div>
  <mat-dialog-actions align="end" style="padding-top: 0px;position: relative;right: 18px;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"      
      (click)="onPost()"
    >Confirm
    </button>
  </mat-dialog-actions>